import React from "react";
import { Users, Building2, Globe, Award } from "lucide-react";
import "./AboutSection.css";

const stats = [
  { icon: <Building2 size={32} />, value: "$3B+", label: "Transactions Arranged" },
  { icon: <Users size={32} />, value: "17+", label: "Years of Excellence" },
  { icon: <Globe size={32} />, value: "24+", label: "African Countries" },
  // { icon: <Award size={32} />, value: "100%", label: "Success Rate" },
];

const AboutSection = () => {
  return (
<section id="about" className="about-section">
  <div className="about-header">
    <h2>
      About <span className="the-color">Benchmark Solutions</span>
    </h2>
    <p>
      Since 2007, Benchmark Solutions Limited has been at the forefront of arranging
      specialized financial solutions for businesses and governments across Africa.
      Based in Nairobi, Kenya, we leverage deep understanding of African markets to
      connect opportunities with capital.
    </p>
  </div>

  <div className="row25">
    {stats.map((stat, index) => (
      <div key={index} className="about-card">
        <div className="stat-icon">{stat.icon}</div>
        <h3 className="stat-value">{stat.value}</h3>
        <p className="stat-label">{stat.label}</p>
      </div>
    ))}
  </div>

  <div className="about-journey">
    <h3>Our Journey</h3>
    <p>
      What began as a vision to bridge the gap between African businesses and global
      capital has evolved into a trusted partnership spanning multiple countries and
      sectors.
    </p>
    <p>
      We bring together strong local knowledge, international best practices, and
      commitment to excellence, making us the preferred partner for businesses
      seeking to scale and governments driving economic transformation.
    </p>
  </div>
</section>

  );
};

export default AboutSection;
